import { useEffect, useState } from "react"
import Wrapper from "./style"
import arrow from '../../assets/Arrow.svg'
import chat from "./chat.svg"
import laptop from "./laptop.svg"
import close from "./close.svg"
import services from "../../services"

export const GetHelp = ({ setShowGetHelp, title, assets }) => {

    const defaultAsset = {name: "general", displayName: "IT Support Team"};

    const [status, setStatus] = useState("Send");
    const [showQueryForm, setShowQueryForm] = useState(!!title);
    const [selectedAsset, setSelectedAsset] = useState(defaultAsset)
    const [body, setBody] = useState("")
    const [statusDisplay, setStatusDisplay] = useState(null)

    const sendMail = (e, selectedAssetName) => {        
        setStatus("Sending Mail...")
        e.target.disabled = true
        const payload = {
            ToAssetId : selectedAsset.assetId,
            Subject : "Query",
            Body : body
        };
        const sendEmail = selectedAssetName === "general" || selectedAssetName === "it-support" ? services.sendEmailToITSupport(payload) : services.sendEmailToAssetId(selectedAsset.assetId, payload)
        sendEmail
        .then(() => {
            setStatusDisplay("Query Sent! Someone will contact you shortly.")
            setTimeout(() => {
                setStatusDisplay(null);
                setShowGetHelp(false);
            }, 2000)
        })
        .catch((ex) => {
            setStatusDisplay(null);
            console.log(ex);
            setStatus("Send");
            e.target.disabled = false;
        });
    }

    const select = (asset, e) => {
        if(window.document.querySelector('.getHelpModal .border-left'))
        window.document.querySelector('.getHelpModal .border-left').classList.remove('border-left')
        if(e.target.nodeName.toLowerCase() === 'p'){
            e.target.parentElement.classList.add('border-left')
        }else{
            e.target.classList.add('border-left')
        }
        setSelectedAsset(asset)
        setShowQueryForm(true)
    }

    const closeQueryForm = () => {
        setShowQueryForm(false);
        setBody('');
        setSelectedAsset(defaultAsset);
    }

    useEffect(() => {
        window.document.querySelector('.getHelpModal:not(.container)').addEventListener('click', e =>{
            if(e.target.classList.contains('getHelpModal')) {
                setShowGetHelp(false)
            }
        });
    }, [setShowGetHelp]);

    return (
        <Wrapper className="getHelpModal">
            <div className={status === "Send" ? "container" : "loading container" }>
                {
                    showQueryForm
                    ? <div className="queryForm">
                        <input className="tertiary" type="button" value="← Back" onClick={closeQueryForm} />
                        <h2>
                            {
                                selectedAsset.name === 'general'
                                ? "Submit a general query"
                                : 'Submit a query to ' + selectedAsset.displayName
                            }
                        </h2>
                        {/* <p>Here you can submit a query
                            {
                                selectedAsset.name !== 'general'
                                ? ' to ' + selectedAsset.name + ' '
                                : ' '
                            }
                            for a more comprehensive study</p> */}
                        <textarea
                            cols="30"
                            rows="5"
                            placeholder="Type your question..."
                            value={body}
                            onChange={e => setBody(e.target.value)}
                            />
                        <br /><br />
                        <div className="flex space-between">
                            <input className="secondary" type="button" value="Cancel" onClick={e => setShowGetHelp(false)} />
                            {
                                statusDisplay ? <p className="statusDisplay">{statusDisplay}</p> : null
                            }
                            <input className="primary" type="button" value={status} onClick={e => sendMail(e, selectedAsset.name)} />
                        </div>
                    </div>
                    : <div className="top">
                    <h1>Get Help</h1>
                    <img className="close" src={close} alt="Close" onClick={e => setShowGetHelp(false)} />
                    <div className="inner">
                        <div className="left">
                            <div className="box" onClick={e => {
                                setSelectedAsset(defaultAsset)
                                setShowQueryForm(true)
                            }}>
                                <div className="flex gap-10">
                                    <img src={chat} alt="" />
                                    <h2>Submit a general query</h2>
                                </div>
                                <p>Here you can place a request that's generic about assets on this portal, i.e., not specific to a given asset</p>
                            </div>
                            <div className="box" onClick={e => {
                                setSelectedAsset({name : 'it-support', displayName: 'IT Support Team'});
                                setShowQueryForm(true);
                            }}>
                                <div className="flex gap-10">
                                    <img src={laptop} alt="" />
                                    <h2>Get IT support</h2>
                                </div>
                                <p>Here you can get quick support from IT to solve your issues</p>
                            </div>
                        </div>
                        {
                            assets.length ? 
                            <div className="right">
                                <div className="head">
                                    {/* <img src={user} alt="" /> */}
                                    <h2>Contact asset</h2>
                                </div>
                                <ul>
                                    {
                                        assets.map(asset => <li key={asset.assetId}>
                                            <button onClick={e => select(asset,e)}>
                                                <p>{asset.displayName}</p>
                                                <img src={arrow} alt="" />
                                            </button>
                                        </li>)
                                    }
                                </ul>
                            </div>
                            : null
                        }
                    </div>
                </div>
                }
                <div className="bottom">
                    {/* <div className="box">
                        <img src="" alt="" />
                        <p>Write us</p>
                    </div>
                    <div className="box">
                        <img src="" alt="" />
                        <p>Chat with us</p>
                    </div>
                    <div className="box">
                        <img src="" alt="" />
                        <p>Call us</p>
                    </div> */}
                </div>
            </div>
        </Wrapper>
    )
}